import { render, staticRenderFns } from "./zlfz.vue?vue&type=template&id=2465f5ee&scoped=true&"
import script from "./zlfz.vue?vue&type=script&lang=js&"
export * from "./zlfz.vue?vue&type=script&lang=js&"
import style0 from "./zlfz.vue?vue&type=style&index=0&id=2465f5ee&scoped=true&lang=css&"
import style1 from "./zlfz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465f5ee",
  null
  
)

export default component.exports